(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-cart-qty]').forEach((wrap) => {
      const input = wrap.querySelector('[data-qty-input]');
      if (!input) return;

      wrap.querySelector('[data-qty-decrease]')?.addEventListener('click', () => {
        input.value = String(Math.max(0, Number(input.value || 1) - 1));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      wrap.querySelector('[data-qty-increase]')?.addEventListener('click', () => {
        input.value = String(Math.max(0, Number(input.value || 0) + 1));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-row"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function activateTab(trigger) {
      const root = trigger.closest('[data-product-tabs]');
      if (!root) return;

      const key = trigger.getAttribute('data-tab-key');
      if (!key) return;

      const panel = Array.from(
        root.querySelectorAll('[data-tab-panel]')
      ).find((item) => item.getAttribute('data-tab-key') === key);

      if (!panel) return;

      const triggers = Array.from(
        root.querySelectorAll('[data-tab-trigger]')
      );

      triggers.forEach((button) => {
        const active = button === trigger;

        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
        button.setAttribute('tabindex', active ? '0' : '-1');
      });

      root.querySelectorAll('[data-tab-panel]').forEach((item) => {
        const active = item === panel;

        item.classList.toggle('is-hidden', !active);
        item.classList.toggle('is-active', active);

        if (active) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
        }
      });

      const viewAll = root.querySelector('[data-tabs-view-all]');
      const url = trigger.getAttribute('data-tab-url');

      if (viewAll && url) {
        viewAll.setAttribute('href', url);
      }
    }

    if (!window.categoryRowTabsInitialized) {
      window.categoryRowTabsInitialized = true;

      document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest('[data-tab-trigger]');
        if (!trigger) return;

        event.preventDefault();
        activateTab(trigger);
      });

      document.addEventListener('keydown', (event) => {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest('[data-tab-trigger]');
        if (!trigger) return;

        const root = trigger.closest('[data-product-tabs]');
        if (!root) return;

        const triggers = Array.from(
          root.querySelectorAll('[data-tab-trigger]')
        );

        const index = triggers.indexOf(trigger);
        if (index < 0 || !triggers.length) return;

        let nextIndex;

        switch (event.key) {
          case 'ArrowRight':
            nextIndex = (index + 1) % triggers.length;
            break;
          case 'ArrowLeft':
            nextIndex = (index - 1 + triggers.length) % triggers.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = triggers.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        triggers[nextIndex].focus();
        activateTab(triggers[nextIndex]);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-rl-hero]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const slides = [...root.querySelectorAll('[data-rl-slide]')];
      const thumbs = [...root.querySelectorAll('[data-rl-thumb]')];
      if (slides.length < 2) return;

      const autoplay = root.dataset.autoplay === 'true';
      const speed = Math.max(3000, Number(root.dataset.speed) || 6000);
      let index = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
      if (index < 0) index = 0;
      let timer = null;
      let touching = false;
      let startX = 0;
      let deltaX = 0;

      const goTo = (next) => {
        const total = slides.length;
        index = ((next % total) + total) % total;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        thumbs.forEach((thumb, i) => {
          const active = i === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        stop();
        if (!autoplay || touching) return;
        timer = window.setInterval(() => goTo(index + 1), speed);
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          goTo(Number(thumb.dataset.index) || 0);
          start();
        });
      });

      const viewport = root.querySelector('[data-rl-viewport]');
      if (viewport) {
        viewport.addEventListener(
          'touchstart',
          (event) => {
            touching = true;
            stop();
            startX = event.touches[0].clientX;
            deltaX = 0;
          },
          { passive: true }
        );
        viewport.addEventListener(
          'touchmove',
          (event) => {
            deltaX = event.touches[0].clientX - startX;
          },
          { passive: true }
        );
        viewport.addEventListener(
          'touchend',
          () => {
            touching = false;
            if (Math.abs(deltaX) > 40) {
              goTo(index + (deltaX < 0 ? 1 : -1));
            }
            start();
          },
          { passive: true }
        );
      }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });

      goTo(index);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-highlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-collection-highlight]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const track = root.querySelector('[data-ch-track]');
      const slides = [...root.querySelectorAll('[data-ch-slide]')];
      const dotsWrap = root.querySelector('[data-ch-dots]');
      if (!track || !slides.length) return;

      let index = 0;
      const total = slides.length;

      const setSlide = (nextIndex, animate = true) => {
        index = Math.max(0, Math.min(total - 1, nextIndex));
        if (!animate) track.style.transition = 'none';
        track.style.transform = `translate3d(0, ${-index * 100}vh, 0)`;
        if (!animate) {
          track.offsetHeight;
          track.style.transition = '';
        }
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        if (dotsWrap) {
          [...dotsWrap.querySelectorAll('[data-ch-dot]')].forEach((dot, i) => {
            const active = i === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        }
      };

      if (dotsWrap && total > 1) {
        dotsWrap.innerHTML = slides
          .map(
            (_, i) =>
              `<button type="button" class="collection-highlight__dot${i === 0 ? ' is-active' : ''}" role="tab" aria-selected="${i === 0}" aria-label="Slide ${i + 1}" data-ch-dot="${i}"></button>`
          )
          .join('');

        dotsWrap.addEventListener('click', (event) => {
          const button = event.target.closest('[data-ch-dot]');
          if (!button) return;
          const target = Number(button.dataset.chDot);
          const rect = root.getBoundingClientRect();
          const top = window.scrollY + rect.top;
          const scrollable = Math.max(root.offsetHeight - window.innerHeight, 1);
          const progress = total <= 1 ? 0 : target / (total - 1);
          window.scrollTo({ top: top + progress * scrollable, behavior: 'smooth' });
        });
      }

      const updateFromScroll = () => {
        if (total <= 1) {
          setSlide(0, false);
          return;
        }
        const rect = root.getBoundingClientRect();
        const scrollable = Math.max(root.offsetHeight - window.innerHeight, 1);
        const scrolled = Math.min(Math.max(-rect.top, 0), scrollable);
        const progress = scrolled / scrollable;
        const nextIndex = Math.min(total - 1, Math.floor(progress * total + 0.0001));
        if (nextIndex !== index) setSlide(nextIndex);
      };

      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateFromScroll();
          ticking = false;
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => {
        setSlide(index, false);
        updateFromScroll();
      });

      setSlide(0, false);
      updateFromScroll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-shop-page]');
    if (!root) return;

    const openBtn = root.querySelector('[data-shop-filter-open]');
    const closeBtn = root.querySelector('[data-shop-filter-close]');
    const backdrop = root.querySelector('[data-shop-filter-backdrop]');
    const form = root.querySelector('[data-shop-filter-form]');
    const sortSelect = root.querySelector('[data-shop-sort]');
    const sortInput = root.querySelector('[data-shop-sort-input]');
    const sortForm = document.getElementById('ShopSortForm');
    const grid = root.querySelector('[data-shop-grid]');
    const items = Array.from(root.querySelectorAll('[data-shop-item]'));
    const emptyFiltered = root.querySelector('[data-shop-empty]');

    const setOpen = (open) => {
      root.classList.toggle('is-filters-open', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (backdrop) backdrop.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };

    openBtn?.addEventListener('click', () => setOpen(true));
    closeBtn?.addEventListener('click', () => setOpen(false));
    backdrop?.addEventListener('click', () => setOpen(false));

    const checkedValues = (predicate) =>
      Array.from(form?.querySelectorAll('input[type="checkbox"]') || [])
        .filter((input) => input.checked && !input.disabled && predicate(input))
        .map((input) => String(input.value || '').trim().toLowerCase())
        .filter(Boolean);

    const applyFilters = () => {
      const categories = checkedValues((input) => input.name === 'filter.p.collection');
      const colorInputs = checkedValues((input) => /color|colour/i.test(input.name));
      const sizeInputs = checkedValues(
        (input) => /size/i.test(input.name) && !/color|colour/i.test(input.name)
      );
      const availability = checkedValues((input) => /availability/i.test(input.name));
      const priceMin = Number(root.querySelector('[data-price-min]')?.value || 0);
      const priceMaxRaw = root.querySelector('[data-price-max]')?.value;
      const priceRangeMax = Number(root.querySelector('[data-price-filter]')?.dataset.rangeMax || 0);
      const priceMax = priceMaxRaw !== undefined && priceMaxRaw !== '' ? Number(priceMaxRaw) : priceRangeMax || Infinity;

      let visible = 0;

      items.forEach((item) => {
        const haystack = String(item.dataset.haystack || '');
        const collectionList = String(item.dataset.collections || '')
          .split('||')
          .map((v) => v.trim())
          .filter(Boolean);
        const sizeList = String(item.dataset.sizes || '')
          .split('||')
          .map((v) => v.trim())
          .filter(Boolean);
        const colorList = String(item.dataset.colors || '')
          .split('||')
          .map((v) => v.trim())
          .filter(Boolean);
        const available = String(item.dataset.available) === 'true';
        const price = Number(item.dataset.price || 0);

        let show = true;

        if (categories.length) {
          show = categories.some((handle) => collectionList.includes(handle));
        }

        if (show && colorInputs.length) {
          show = colorInputs.some(
            (color) => colorList.includes(color) || haystack.includes(color)
          );
        }

        if (show && sizeInputs.length) {
          show = sizeInputs.some((size) => sizeList.includes(size));
        }

        if (show && availability.length) {
          const wantIn = availability.some((v) => v === '1' || v.includes('in'));
          const wantOut = availability.some((v) => v === '0' || v.includes('out'));
          if (wantIn && !wantOut) show = available;
          else if (wantOut && !wantIn) show = !available;
        }

        if (show && priceRangeMax > 0) {
          if (price < priceMin || price > priceMax) show = false;
        }

        item.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });

      if (grid) grid.hidden = visible === 0;
      if (emptyFiltered) emptyFiltered.hidden = visible !== 0;

      root.querySelectorAll('.shop-check, .shop-swatch').forEach((label) => {
        const input = label.querySelector('input[type="checkbox"]');
        if (input) label.classList.toggle('is-active', input.checked);
      });
    };

    form?.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', (event) => {
        event.preventDefault();
        applyFilters();
      });
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      applyFilters();
      setOpen(false);
    });

    sortSelect?.addEventListener('change', () => {
      if (sortInput) sortInput.value = sortSelect.value;
      sortForm?.submit();
    });

    const price = root.querySelector('[data-price-filter]');
    if (price) {
      const track = price.querySelector('[data-price-track]');
      const rangeMin = price.querySelector('[data-range-min]');
      const rangeMax = price.querySelector('[data-range-max]');
      const hiddenMin = price.querySelector('[data-price-min]');
      const hiddenMax = price.querySelector('[data-price-max]');
      const display = price.querySelector('[data-price-display]');
      const max = Number(price.dataset.rangeMax || 0);

      const formatMoney = (cents) => {
        const value = Number(cents || 0) / 100;
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR',
            maximumFractionDigits: 0,
          }).format(value);
        } catch (e) {
          return 'PKR ' + Math.round(value).toLocaleString();
        }
      };

      const sync = (runFilter) => {
        let minVal = Number(rangeMin.value);
        let maxVal = Number(rangeMax.value);
        if (minVal > maxVal) {
          const t = minVal;
          minVal = maxVal;
          maxVal = t;
          rangeMin.value = minVal;
          rangeMax.value = maxVal;
        }
        const left = max ? (minVal / max) * 100 : 0;
        const right = max ? (maxVal / max) * 100 : 100;
        if (track) {
          track.style.left = left + '%';
          track.style.width = Math.max(0, right - left) + '%';
        }
        if (hiddenMin) hiddenMin.value = String(minVal);
        if (hiddenMax) hiddenMax.value = String(maxVal);
        if (display) display.textContent = formatMoney(minVal) + ' - ' + formatMoney(maxVal);
        if (runFilter) applyFilters();
      };

      rangeMin?.addEventListener('input', () => sync(true));
      rangeMax?.addEventListener('input', () => sync(true));
      sync(false);
    }

    applyFilters();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.Shopify && Shopify.designMode) return;

    const sliders = document.querySelectorAll('[data-product-slider]');
    if (!sliders.length) return;

    sliders.forEach((root) => {
      const viewport = root.querySelector('[data-slider-viewport]');
      const prev = root.querySelector('[data-slider-prev]');
      const next = root.querySelector('[data-slider-next]');
      if (!viewport || !prev || !next) return;

      const card = () => viewport.querySelector('.product-card');

      const step = () => {
        const item = card();
        if (!item) return viewport.clientWidth;
        const styles = window.getComputedStyle(viewport.querySelector('.product-slider__track'));
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '16') || 16;
        return item.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
        prev.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft >= max;
      };

      prev.addEventListener('click', () => {
        viewport.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', () => {
        viewport.scrollBy({ left: step(), behavior: 'smooth' });
      });
      viewport.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const KEY = 'stitch-wishlist';
    const toggle = document.querySelector('[data-mobile-nav-toggle]');
    const nav = document.querySelector('[data-mobile-nav]');
    const closeBtn = document.querySelector('[data-mobile-nav-close]');
    const drawer = document.querySelector('[data-wishlist-drawer]');
    const body = document.querySelector('[data-wishlist-body]');
    const openBtns = document.querySelectorAll('[data-wishlist-open]');

    document.querySelectorAll('[data-mega-item]').forEach((item) => {
      const trigger = item.querySelector('[data-mega-trigger]');
      const panel = item.querySelector('[data-mega-panel]');
      if (!trigger || !panel) return;
      let closeTimer = null;

      const setOpen = (open) => {
        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      };

      const openMega = () => {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        setOpen(true);
      };

      const closeMega = () => {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(() => setOpen(false), 280);
      };

      item.addEventListener('mouseenter', openMega);
      item.addEventListener('mouseleave', closeMega);
      panel.addEventListener('mouseenter', openMega);
      panel.addEventListener('mouseleave', closeMega);
      item.addEventListener('focusin', openMega);
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) closeMega();
      });

      const megaLinks = [...panel.querySelectorAll('[data-mega-link]')];
      const megaTiles = [...panel.querySelectorAll('[data-mega-tile]')];
      const highlight = (index) => {
        const hasTile = index && megaTiles.some((tile) => tile.dataset.megaTile === index);
        megaLinks.forEach((megaLink) => megaLink.classList.toggle('is-hover', megaLink.dataset.megaLink === index));
        megaTiles.forEach((tile) => {
          tile.classList.toggle('is-hover', tile.dataset.megaTile === index);
          tile.classList.toggle('is-dim', Boolean(hasTile) && tile.dataset.megaTile !== index);
        });
      };
      megaLinks.forEach((megaLink) => {
        megaLink.addEventListener('mouseenter', () => highlight(megaLink.dataset.megaLink));
        megaLink.addEventListener('mouseleave', () => highlight(null));
      });
      megaTiles.forEach((tile) => {
        tile.addEventListener('mouseenter', () => highlight(tile.dataset.megaTile));
        tile.addEventListener('mouseleave', () => highlight(null));
      });
    });

    const readWishlist = () => {
      try {
        const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(raw) ? raw : [];
      } catch (error) {
        return [];
      }
    };

    const writeWishlist = (list) => {
      localStorage.setItem(KEY, JSON.stringify(list));
      document.dispatchEvent(new CustomEvent('stitch:wishlist-change', { detail: { count: list.length } }));
    };

    const syncWishlistCount = () => {
      const count = readWishlist().length;
      document.querySelectorAll('[data-wishlist-count]').forEach((badge) => {
        badge.textContent = String(count);
        badge.hidden = count < 1;
        if (count > 0) badge.removeAttribute('hidden');
      });
    };

    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const renderWishlist = () => {
      if (!body) return;
      const list = readWishlist();
      if (!list.length) {
        body.innerHTML = '<p class="wishlist-drawer__empty">Your wishlist is empty.</p>';
        return;
      }
      body.innerHTML =
        '<div class="wishlist-drawer__list">' +
        list
          .map((item) => {
            const id = escapeHtml(item.id || item);
            const title = escapeHtml(item.title || 'Product');
            const url = escapeHtml(item.url || '#');
            const image = escapeHtml(item.image || '');
            const price = escapeHtml(item.price || '');
            return (
              '<article class="wishlist-drawer__item" data-wish-id="' +
              id +
              '">' +
              '<a class="wishlist-drawer__thumb" href="' +
              url +
              '">' +
              (image
                ? '<img src="' + image + '" alt="' + title + '" width="144" height="192" loading="lazy">'
                : '') +
              '</a>' +
              '<div class="wishlist-drawer__info">' +
              '<a class="wishlist-drawer__name" href="' +
              url +
              '">' +
              title +
              '</a>' +
              (price ? '<p class="wishlist-drawer__price">' + price + '</p>' : '') +
              '</div>' +
              '<button type="button" class="wishlist-drawer__remove" data-wish-remove aria-label="Remove">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>' +
              '</button></article>'
            );
          })
          .join('') +
        '</div>';
    };

    const openWishlist = () => {
      if (!drawer) return;
      renderWishlist();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('wishlist-drawer-open');
      openBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
    };

    const closeWishlist = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wishlist-drawer-open');
      openBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    };

    window.StitchWishlist = window.StitchWishlist || {};
    window.StitchWishlist.syncCount = syncWishlistCount;
    window.StitchWishlist.open = openWishlist;
    window.StitchWishlist.close = closeWishlist;
    window.StitchWishlist.render = renderWishlist;

    syncWishlistCount();
    document.addEventListener('stitch:wishlist-change', () => {
      syncWishlistCount();
      if (drawer?.classList.contains('is-open')) renderWishlist();
    });
    window.addEventListener('storage', (event) => {
      if (event.key === KEY) {
        syncWishlistCount();
        if (drawer?.classList.contains('is-open')) renderWishlist();
      }
    });

    openBtns.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        if (drawer?.classList.contains('is-open')) closeWishlist();
        else openWishlist();
      });
    });

    drawer?.querySelectorAll('[data-wishlist-close]').forEach((el) => {
      el.addEventListener('click', (event) => {
        if (el.tagName === 'A') {
          closeWishlist();
          return;
        }
        event.preventDefault();
        closeWishlist();
      });
    });

    body?.addEventListener('click', (event) => {
      const removeBtn = event.target.closest('[data-wish-remove]');
      if (!removeBtn) return;
      event.preventDefault();
      const card = removeBtn.closest('[data-wish-id]');
      const id = card?.getAttribute('data-wish-id');
      if (!id) return;
      writeWishlist(readWishlist().filter((item) => String(item.id || item) !== id));
      syncWishlistCount();
      renderWishlist();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer?.classList.contains('is-open')) closeWishlist();
    });

    if (!toggle || !nav) return;

    let navCloseTimer = null;

    const open = () => {
      clearTimeout(navCloseTimer);
      nav.hidden = false;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => nav.classList.add('is-open'));
      });
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    };

    const close = () => {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      clearTimeout(navCloseTimer);
      navCloseTimer = setTimeout(() => {
        if (!nav.classList.contains('is-open')) nav.hidden = true;
      }, 350);
    };

    toggle.addEventListener('click', () => {
      if (nav.classList.contains('is-open')) close();
      else open();
    });

    nav.querySelectorAll('[data-mobile-sub-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const sub = document.getElementById(btn.getAttribute('aria-controls'));
        if (!sub) return;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        sub.classList.toggle('is-open', !expanded);
      });
    });

    closeBtn?.addEventListener('click', close);
    nav.addEventListener('click', (event) => {
      if (event.target === nav) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.Shopify && Shopify.designMode) return;

    const root = document.querySelector('[data-hero-slider]');
    if (!root) return;

    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    if (slides.length < 2) return;

    const dots = [...root.querySelectorAll('[data-hero-dot]')];
    const autoplay = root.dataset.autoplay === 'true';
    const interval = Number(root.dataset.interval || 5000);
    let index = 0;
    let timer;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const start = () => {
      if (!autoplay) return;
      stop();
      timer = window.setInterval(() => show(index + 1), interval);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        show(Number(dot.dataset.index || 0));
        start();
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    let touchX = 0;
    root.addEventListener('touchstart', (event) => {
      touchX = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const delta = (event.changedTouches[0]?.clientX || 0) - touchX;
      if (Math.abs(delta) < 40) return;
      show(delta < 0 ? index + 1 : index - 1);
      start();
    }, { passive: true });

    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const init = () => {
      const root = document.querySelector('[data-product-page]');
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const cartRoot = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const jsonEl = root.querySelector('[data-product-json]');
      const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
      const variantInput = root.querySelector('[data-variant-id]');
      const priceEl = root.querySelector('[data-product-price]');
      const compareEl = root.querySelector('[data-product-compare]');
      const saveEl = root.querySelector('[data-product-save]');
      const skuEl = root.querySelector('[data-product-sku]');
      const skuExtra = root.querySelector('[data-product-sku-extra]');
      const stockEl = root.querySelector('[data-product-stock]');
      const stockLabel = root.querySelector('[data-stock-label]');
      const button = root.querySelector('[data-add-to-cart]');
      const buyNow = root.querySelector('[data-buy-now]');
      const optionInputs = [...root.querySelectorAll('[data-option-input]')];
      const mainImage = root.querySelector('[data-main-image]');
      const slides = [...root.querySelectorAll('[data-media-slide]')];
      const mediaStack = root.querySelector('[data-media-stack]');
      const mediaViewport = root.querySelector('[data-media-viewport]');
      const thumbsRoot = root.querySelector('[data-media-thumbs]');
      const thumbs = thumbsRoot ? [...thumbsRoot.querySelectorAll('[data-media-thumb]')] : [];
      const lightbox = root.querySelector('[data-lightbox]');
      const lightboxTrack = root.querySelector('[data-lightbox-track]');
      const lightboxCounter = root.querySelector('[data-lightbox-counter]');
      const qtyInput = root.querySelector('[data-qty-input]');
      let activeSlide = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      if (activeSlide < 0) activeSlide = 0;
      let lightboxIndex = 0;
      let lightboxZoomed = false;
      let lightboxPan = { x: 0, y: 0 };
      let lightboxDragging = false;
      let dragStart = { x: 0, y: 0, panX: 0, panY: 0 };
      let swipeStartX = 0;
      let swipeDeltaX = 0;

      const isDesktopGallery = () => window.matchMedia('(min-width: 990px)').matches;

      const getSlideWidth = () =>
        mediaViewport?.clientWidth || mediaStack?.parentElement?.clientWidth || root.clientWidth || 0;

      const syncMobileSlider = () => {
        if (!mediaStack || !slides.length) return;
        if (isDesktopGallery()) {
          mediaStack.style.transform = '';
          slides.forEach((slide) => slide.classList.remove('is-active'));
          return;
        }
        slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === activeSlide);
        });
        const width = getSlideWidth();
        const styles = window.getComputedStyle(mediaStack);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        mediaStack.style.transform = width
          ? `translate3d(-${activeSlide * (width + gap)}px, 0, 0)`
          : `translate3d(calc(-${activeSlide * 100}% - ${activeSlide * gap}px), 0, 0)`;
        thumbs.forEach((thumb, index) => {
          const active = index === activeSlide;
          thumb.classList.toggle('is-active', active);
          if (active) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
        const activeThumb = thumbs[activeSlide];
        if (thumbsRoot && activeThumb) {
          const left = activeThumb.offsetLeft;
          const right = left + activeThumb.offsetWidth;
          if (left < thumbsRoot.scrollLeft || right > thumbsRoot.scrollLeft + thumbsRoot.clientWidth) {
            thumbsRoot.scrollTo({ left: Math.max(0, left - thumbsRoot.clientWidth / 2 + activeThumb.offsetWidth / 2), behavior: 'smooth' });
          }
        }
      };

      const goToSlide = (index) => {
        if (!slides.length) return;
        activeSlide = (index + slides.length) % slides.length;
        syncMobileSlider();
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => goToSlide(index));
      });
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => goToSlide(activeSlide - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => goToSlide(activeSlide + 1));

      let touchStartX = 0;
      mediaStack?.addEventListener('touchstart', (event) => {
        if (isDesktopGallery()) return;
        touchStartX = event.changedTouches[0]?.clientX || 0;
      }, { passive: true });
      mediaStack?.addEventListener('touchend', (event) => {
        if (isDesktopGallery()) return;
        const delta = (event.changedTouches[0]?.clientX || 0) - touchStartX;
        if (Math.abs(delta) < 40) return;
        goToSlide(delta < 0 ? activeSlide + 1 : activeSlide - 1);
      }, { passive: true });

      const lightboxItems = slides.map((slide) => ({
        src: slide.dataset.mediaSrc,
        alt: slide.dataset.mediaAlt || ''
      }));

      if (lightboxTrack && lightboxItems.length) {
        lightboxTrack.innerHTML = lightboxItems
          .map(
            (item) =>
              '<div class="product-pswp__item" data-lightbox-item>' +
              '<div class="product-pswp__img-wrap" data-lightbox-wrap>' +
              '<img class="product-pswp__img" src="' +
              item.src +
              '" alt="' +
              String(item.alt).replace(/"/g, '&quot;') +
              '" width="1600" height="2000" draggable="false">' +
              '</div></div>'
          )
          .join('');
      }

      const getActiveWrap = () =>
        lightboxTrack?.querySelectorAll('[data-lightbox-wrap]')?.[lightboxIndex] || null;

      const setLightboxTransform = (withTransition = true) => {
        if (!lightboxTrack) return;
        lightboxTrack.style.transition = withTransition ? '' : 'none';
        lightboxTrack.style.transform =
          'translate3d(calc(' + -lightboxIndex * 100 + '% + ' + swipeDeltaX + 'px), 0, 0)';
        if (!withTransition) {
          lightboxTrack.offsetHeight;
          lightboxTrack.style.transition = '';
        }
      };

      const resetZoom = () => {
        lightboxZoomed = false;
        lightboxPan = { x: 0, y: 0 };
        lightbox?.classList.remove('is-zoomed');
        lightboxTrack?.querySelectorAll('[data-lightbox-wrap]').forEach((wrap) => {
          wrap.style.transform = '';
          wrap.classList.remove('is-dragging');
        });
      };

      const applyZoomTransform = () => {
        const wrap = getActiveWrap();
        if (!wrap) return;
        wrap.style.transform = lightboxZoomed
          ? 'translate3d(' + lightboxPan.x + 'px, ' + lightboxPan.y + 'px, 0) scale(2.4)'
          : '';
      };

      const updateLightboxCounter = () => {
        if (!lightboxCounter) return;
        lightboxCounter.textContent = lightboxItems.length
          ? lightboxIndex + 1 + ' / ' + lightboxItems.length
          : '';
      };

      const goLightbox = (index) => {
        if (!lightboxItems.length) return;
        resetZoom();
        lightboxIndex = (index + lightboxItems.length) % lightboxItems.length;
        swipeDeltaX = 0;
        setLightboxTransform(true);
        updateLightboxCounter();
      };

      const openLightbox = (index) => {
        if (!lightbox || !lightboxItems.length) return;
        lightboxIndex = Math.max(0, Math.min(index || 0, lightboxItems.length - 1));
        resetZoom();
        swipeDeltaX = 0;
        setLightboxTransform(false);
        updateLightboxCounter();
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () {
          lightbox.classList.add('is-open');
        });
        document.documentElement.style.overflow = 'hidden';
      };

      const closeLightbox = () => {
        if (!lightbox || lightbox.hidden) return;
        lightbox.classList.remove('is-open');
        resetZoom();
        window.setTimeout(function () {
          lightbox.hidden = true;
          lightbox.setAttribute('aria-hidden', 'true');
        }, 220);
        document.documentElement.style.overflow = '';
      };

      const toggleLightboxZoom = () => {
        lightboxZoomed = !lightboxZoomed;
        lightbox?.classList.toggle('is-zoomed', lightboxZoomed);
        if (!lightboxZoomed) lightboxPan = { x: 0, y: 0 };
        applyZoomTransform();
      };

      root.querySelectorAll('[data-lightbox-open]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const slide = btn.closest('[data-media-slide]');
          const index = Math.max(0, slides.indexOf(slide));
          openLightbox(index);
        });
      });

      root.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
      root.querySelector('[data-lightbox-bg]')?.addEventListener('click', closeLightbox);
      root.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => goLightbox(lightboxIndex - 1));
      root.querySelector('[data-lightbox-next]')?.addEventListener('click', () => goLightbox(lightboxIndex + 1));
      root.querySelector('[data-lightbox-zoom]')?.addEventListener('click', toggleLightboxZoom);

      lightboxTrack?.querySelectorAll('[data-lightbox-wrap]').forEach((wrap) => {
        wrap.addEventListener('click', (event) => {
          if (Math.abs(swipeDeltaX) > 8) return;
          event.stopPropagation();
          toggleLightboxZoom();
        });
      });

      const onPointerDown = (event) => {
        if (!lightbox || lightbox.hidden || !lightbox.classList.contains('is-open')) return;
        if (event.target.closest('.product-pswp__button')) return;
        const point = event.touches ? event.touches[0] : event;
        swipeStartX = point.clientX;
        swipeDeltaX = 0;
        if (lightboxZoomed) {
          lightboxDragging = true;
          dragStart = { x: point.clientX, y: point.clientY, panX: lightboxPan.x, panY: lightboxPan.y };
          getActiveWrap()?.classList.add('is-dragging');
        }
      };

      const onPointerMove = (event) => {
        if (!lightbox || lightbox.hidden) return;
        const point = event.touches ? event.touches[0] : event;
        if (lightboxZoomed && lightboxDragging) {
          lightboxPan = {
            x: dragStart.panX + (point.clientX - dragStart.x),
            y: dragStart.panY + (point.clientY - dragStart.y)
          };
          applyZoomTransform();
          event.preventDefault();
          return;
        }
        if ((event.touches || event.buttons === 1) && swipeStartX && !lightboxZoomed) {
          swipeDeltaX = point.clientX - swipeStartX;
          setLightboxTransform(false);
        }
      };

      const onPointerUp = () => {
        if (!lightbox || lightbox.hidden) return;
        if (lightboxZoomed) {
          lightboxDragging = false;
          getActiveWrap()?.classList.remove('is-dragging');
          swipeStartX = 0;
          return;
        }
        if (Math.abs(swipeDeltaX) > 60) {
          goLightbox(swipeDeltaX < 0 ? lightboxIndex + 1 : lightboxIndex - 1);
        } else {
          swipeDeltaX = 0;
          setLightboxTransform(true);
        }
        swipeStartX = 0;
        swipeDeltaX = 0;
      };

      lightbox?.addEventListener('mousedown', onPointerDown);
      lightbox?.addEventListener('touchstart', onPointerDown, { passive: true });
      window.addEventListener('mousemove', onPointerMove);
      window.addEventListener('touchmove', onPointerMove, { passive: false });
      window.addEventListener('mouseup', onPointerUp);
      window.addEventListener('touchend', onPointerUp);

      document.addEventListener('keydown', (event) => {
        if (!lightbox || lightbox.hidden) return;
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') goLightbox(lightboxIndex - 1);
        if (event.key === 'ArrowRight') goLightbox(lightboxIndex + 1);
      });
      window.addEventListener('resize', syncMobileSlider);
      syncMobileSlider();

      const formatCents = (cents) => {
        if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) {
          return Shopify.formatMoney(cents, Shopify.money_format);
        }
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR',
            minimumFractionDigits: 0
          }).format(Number(cents) / 100);
        } catch (error) {
          return String(Math.round(Number(cents) / 100));
        }
      };

      const selectedOptions = () => {
        const values = [];
        optionInputs.forEach((input) => {
          if (!input.checked) return;
          values[Number(input.dataset.optionPosition) - 1] = input.value;
        });
        return values;
      };

      const findVariant = () => {
        if (!product || !product.variants) return null;
        const selected = selectedOptions();
        if (!selected.filter(Boolean).length) return product.variants[0];
        return product.variants.find((variant) =>
          variant.options.every((option, index) => option === selected[index])
        );
      };

      const updateVariant = () => {
        const variant = findVariant();
        if (!variant || !variantInput) {
          if (button) {
            button.disabled = true;
            const label = button.querySelector('span');
            if (label) label.textContent = button.dataset.labelSoldout || 'Unavailable';
          }
          if (buyNow) buyNow.disabled = true;
          return;
        }

        variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatCents(variant.price);

        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compareEl) {
          if (onSale) {
            compareEl.hidden = false;
            compareEl.textContent = formatCents(variant.compare_at_price);
          } else {
            compareEl.hidden = true;
          }
        }
        if (saveEl) {
          if (onSale) {
            const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            if (pct > 0) {
              saveEl.hidden = false;
              saveEl.textContent = `Save ${pct}%`;
            } else {
              saveEl.hidden = true;
            }
          } else {
            saveEl.hidden = true;
          }
        }

        if (skuEl) skuEl.textContent = variant.sku || '';
        if (skuExtra) skuExtra.textContent = variant.sku || '';

        if (stockEl && stockLabel) {
          stockEl.classList.toggle('is-out', !variant.available);
          stockLabel.textContent = variant.available ? 'In Stock – Ready to ship.' : (button?.dataset.labelSoldout || 'Sold out');
        }

        if (button) {
          button.disabled = !variant.available;
          const label = button.querySelector('span');
          if (label) {
            label.textContent = variant.available
              ? button.dataset.labelAvailable
              : button.dataset.labelSoldout;
          }
        }
        if (buyNow) buyNow.disabled = !variant.available;

        optionInputs.forEach((input) => {
          if (!input.checked) return;
          const label = input.closest('[data-option-group]')?.querySelector('[data-option-selected-label]');
          if (label) label.textContent = input.value;
        });

        if (variant.featured_image && variant.featured_image.src) {
          const imageSrc = variant.featured_image.src;
          const base = imageSrc.split('?')[0].replace(/_\d+x(\.[a-zA-Z]+)$/i, '$1');
          const matchIndex = slides.findIndex((slide) => {
            const slideBase = (slide.dataset.mediaSrc || '').split('?')[0].replace(/_\d+x(\.[a-zA-Z]+)$/i, '$1');
            return slideBase === base || (slide.dataset.mediaSrc || '').includes(base.split('/').pop()?.replace(/\.[^.]+$/, '') || '___');
          });
          if (matchIndex >= 0) {
            goToSlide(matchIndex);
            if (isDesktopGallery() && !document.documentElement.classList.contains('product-video-modal-open')) {
              slides[matchIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          } else if (mainImage) {
            mainImage.src = imageSrc;
            mainImage.alt = variant.featured_image.alt || product?.title || '';
          }
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
      };

      optionInputs.forEach((input) => input.addEventListener('change', updateVariant));

      root.querySelector('[data-qty-decrease]')?.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) - 1));
      });
      root.querySelector('[data-qty-increase]')?.addEventListener('click', () => {
        if (!qtyInput) return;
        qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) + 1));
      });

      const addToCartAjax = async () => {
        if (!variantInput?.value) throw new Error('No variant');
        const response = await fetch(`${cartRoot()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: Number(variantInput.value),
            quantity: Math.max(1, Number(qtyInput?.value || 1))
          })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Add failed');
        const cart = await fetch(`${cartRoot()}cart.js`, { credentials: 'same-origin' }).then((r) => r.json());
        document.querySelectorAll('[data-cart-count]').forEach((badge) => {
          badge.textContent = String(cart.item_count);
          badge.hidden = cart.item_count < 1;
          if (cart.item_count > 0) badge.removeAttribute('hidden');
        });
        if (window.StitchQuickAdd?.refreshCartSubtotal) window.StitchQuickAdd.refreshCartSubtotal();
        return cart;
      };

      root.querySelector('[data-product-form]')?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!button || button.disabled) return;
        const label = button.querySelector('span');
        const prev = label?.textContent || '';
        button.disabled = true;
        if (label) label.textContent = 'Adding…';
        try {
          await addToCartAjax();
          if (label) label.textContent = 'Added';
          if (window.StitchQuickAdd?.openCart) {
            window.StitchQuickAdd.openCart();
          }
          window.setTimeout(() => {
            if (label) label.textContent = button.dataset.labelAvailable || prev;
            button.disabled = false;
          }, 1000);
        } catch (error) {
          if (label) label.textContent = prev;
          button.disabled = false;
          window.location.href = product?.url || `${cartRoot()}cart`;
        }
      });

      buyNow?.addEventListener('click', async () => {
        if (buyNow.disabled) return;
        buyNow.disabled = true;
        try {
          await addToCartAjax();
          window.location.assign(`${cartRoot()}checkout`);
        } catch (error) {
          buyNow.disabled = false;
          window.location.href = `${cartRoot()}cart`;
        }
      });

      const wish = root.querySelector('[data-product-wishlist]');
      if (wish) {
        const id = String(wish.dataset.productId || '');
        const key = 'stitch-wishlist';
        const read = () => {
          try {
            const raw = JSON.parse(localStorage.getItem(key) || '[]');
            return Array.isArray(raw) ? raw : [];
          } catch (error) {
            return [];
          }
        };
        if (read().some((item) => String(item.id || item) === id)) wish.classList.add('is-active');
        wish.addEventListener('click', () => {
          const list = read();
          const exists = list.some((item) => String(item.id || item) === id);
          const next = exists
            ? list.filter((item) => String(item.id || item) !== id)
            : list.concat({
                id,
                title: root.querySelector('.product-page__title')?.textContent?.trim() || '',
                url: window.location.pathname,
                image: mainImage?.getAttribute('src') || slides[0]?.dataset.mediaSrc || '',
                price: priceEl?.textContent?.trim() || ''
              });
          localStorage.setItem(key, JSON.stringify(next));
          wish.classList.toggle('is-active', !exists);
          document.dispatchEvent(new CustomEvent('stitch:wishlist-change', { detail: { count: next.length } }));
          if (window.StitchWishlist?.syncCount) window.StitchWishlist.syncCount();
        });
      }

      const sizeChart = root.querySelector('[data-size-chart]');
      const sizeChartOpen = root.querySelector('[data-size-chart-open]');
      if (sizeChart && sizeChartOpen) {
        const closeSizeChart = () => {
          sizeChart.hidden = true;
          document.documentElement.style.overflow = '';
          sizeChartOpen.focus();
        };
        sizeChartOpen.addEventListener('click', () => {
          sizeChart.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          sizeChart.querySelector('.product-size-chart__close')?.focus();
        });
        sizeChart.querySelectorAll('[data-size-chart-close]').forEach((el) => {
          el.addEventListener('click', closeSizeChart);
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !sizeChart.hidden) closeSizeChart();
        });
      }

      const floatVideo = root.querySelector('[data-float-video]');
      if (floatVideo) {
        const media = floatVideo.querySelector('[data-float-video-media]');
        const modal = root.querySelector('[data-video-modal]');
        const modalVideo = modal?.querySelector('[data-video-modal-media]');
        const modalMute = modal?.querySelector('[data-video-modal-mute]');
        const modalAtc = modal?.querySelector('[data-video-modal-atc]');
        const modalAtcLabel = modal?.querySelector('[data-video-modal-atc-label]');
        const modalPrice = modal?.querySelector('[data-video-modal-price]');
        const modalOptionBtns = modal ? [...modal.querySelectorAll('[data-video-modal-option]')] : [];
        const edge = 8;

        const place = (x, y) => {
          const maxX = Math.max(edge, window.innerWidth - floatVideo.offsetWidth - edge);
          const maxY = Math.max(edge, window.innerHeight - floatVideo.offsetHeight - edge);
          floatVideo.style.left = `${Math.min(Math.max(edge, x), maxX)}px`;
          floatVideo.style.top = `${Math.min(Math.max(edge, y), maxY)}px`;
          floatVideo.style.right = 'auto';
          floatVideo.style.bottom = 'auto';
        };

        if (media) {
          media.muted = true;
          media.play()?.catch(() => {});
        }

        const setModalMuted = (muted) => {
          if (!modalVideo) return;
          modalVideo.muted = muted;
          modal.classList.toggle('is-muted', muted);
          modalMute?.setAttribute('aria-pressed', String(muted));
          modalMute?.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
        };

        const syncModalProduct = () => {
          if (modalPrice && priceEl) modalPrice.textContent = priceEl.textContent.trim();
          const selected = selectedOptions();
          modalOptionBtns.forEach((btn) => {
            const position = Number(btn.dataset.position) - 1;
            const active = selected[position] === btn.dataset.value;
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-pressed', String(active));
            if (product?.variants) {
              const available = product.variants.some(
                (variant) =>
                  variant.available &&
                  variant.options[position] === btn.dataset.value &&
                  variant.options.every((value, index) => index === position || !selected[index] || value === selected[index])
              );
              btn.classList.toggle('is-unavailable', !available);
            }
          });
          modal?.querySelectorAll('[data-video-modal-option-label]').forEach((label) => {
            label.textContent = selected[Number(label.dataset.videoModalOptionLabel) - 1] || '';
          });
          if (modalAtc && button) {
            modalAtc.disabled = button.disabled;
            const mainLabel = button.querySelector('span')?.textContent.trim();
            if (modalAtcLabel && mainLabel) modalAtcLabel.textContent = mainLabel;
          }
        };

        const openVideoModal = () => {
          if (!modal || !modalVideo) return;
          syncModalProduct();
          if (!modalVideo.getAttribute('src')) modalVideo.src = modalVideo.dataset.src;
          if (media) modalVideo.currentTime = media.currentTime || 0;
          modal.hidden = false;
          document.documentElement.classList.add('product-video-modal-open');
          media?.pause();
          setModalMuted(false);
          modalVideo.play()?.catch(() => {
            setModalMuted(true);
            modalVideo.play()?.catch(() => {});
          });
          modal.querySelector('.product-video-modal__close')?.focus();
        };

        const closeVideoModal = () => {
          if (!modal || modal.hidden) return;
          modalVideo?.pause();
          modal.hidden = true;
          document.documentElement.classList.remove('product-video-modal-open');
          media?.play()?.catch(() => {});
          floatVideo.focus();
        };

        modal?.querySelectorAll('[data-video-modal-close]').forEach((el) => {
          el.addEventListener('click', closeVideoModal);
        });
        modalMute?.addEventListener('click', () => setModalMuted(!modalVideo.muted));
        modalOptionBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            const input = optionInputs.find(
              (item) => item.dataset.optionPosition === btn.dataset.position && item.value === btn.dataset.value
            );
            if (!input) return;
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            syncModalProduct();
          });
        });
        modalAtc?.addEventListener('click', () => {
          if (!button || button.disabled) return;
          closeVideoModal();
          const form = root.querySelector('[data-product-form]');
          if (form?.requestSubmit) form.requestSubmit(button);
          else button.click();
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') closeVideoModal();
        });
        floatVideo.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openVideoModal();
          }
        });

        let drag = null;
        floatVideo.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;
          const rect = floatVideo.getBoundingClientRect();
          drag = {
            id: event.pointerId,
            startX: event.clientX,
            startY: event.clientY,
            offsetX: event.clientX - rect.left,
            offsetY: event.clientY - rect.top,
            moved: false
          };
          floatVideo.setPointerCapture(event.pointerId);
        });
        floatVideo.addEventListener('pointermove', (event) => {
          if (!drag || event.pointerId !== drag.id) return;
          if (!drag.moved && Math.hypot(event.clientX - drag.startX, event.clientY - drag.startY) < 5) return;
          drag.moved = true;
          floatVideo.classList.add('is-dragging');
          place(event.clientX - drag.offsetX, event.clientY - drag.offsetY);
        });
        const endDrag = (event) => {
          if (!drag || event.pointerId !== drag.id) return;
          const moved = drag.moved;
          drag = null;
          floatVideo.classList.remove('is-dragging');
          if (!moved && event.type === 'pointerup') openVideoModal();
        };
        floatVideo.addEventListener('pointerup', endDrag);
        floatVideo.addEventListener('pointercancel', endDrag);

        window.addEventListener('resize', () => {
          if (!floatVideo.style.left) return;
          const rect = floatVideo.getBoundingClientRect();
          place(rect.left, rect.top);
        });
      }

      const stickyAtc = root.querySelector('[data-sticky-atc]');
      const stickyBtn = stickyAtc?.querySelector('[data-sticky-atc-btn]');
      if (stickyAtc && stickyBtn && button) {
        const stickyLabel = stickyAtc.querySelector('[data-sticky-atc-label]');
        const syncSticky = () => {
          stickyBtn.disabled = button.disabled;
          const mainLabel = button.querySelector('span')?.textContent.trim();
          if (stickyLabel && mainLabel) stickyLabel.textContent = mainLabel;
        };
        new MutationObserver(syncSticky).observe(button, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true
        });

        const setStickyVisible = (visible) => {
          stickyAtc.classList.toggle('is-visible', visible);
          stickyAtc.setAttribute('aria-hidden', String(!visible));
          stickyBtn.tabIndex = visible ? 0 : -1;
          document.documentElement.classList.toggle('has-sticky-atc', visible);
        };

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(([entry]) => {
            setStickyVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          }).observe(button);
        }

        stickyBtn.addEventListener('click', () => {
          if (button.disabled) return;
          const form = root.querySelector('[data-product-form]');
          if (form?.requestSubmit) form.requestSubmit(button);
          else button.click();
        });
        syncSticky();
      }

      updateVariant();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-buy-reels"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-watch-buy]');
    if (!roots.length) return;

    const isDesignMode = Boolean(window.Shopify && Shopify.designMode);
    const iconMute = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 10v4h3l5 4V6L7 10H4z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M16 9.5c1.2.9 1.2 4.1 0 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>`;
    const iconUnmute = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 10v4h3l5 4V6L7 10H4z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M18 8l3 3-3 3M21 11h-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>`;
    const iconShare = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="18" cy="5" r="2.2" stroke="currentColor" stroke-width="1.6"/><circle cx="6" cy="12" r="2.2" stroke="currentColor" stroke-width="1.6"/><circle cx="18" cy="19" r="2.2" stroke="currentColor" stroke-width="1.6"/><path d="M8 12.8l7.2 4.1M15.2 6.9 8 10.9" stroke="currentColor" stroke-width="1.6"/></svg>`;
    const iconLink = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 17L17 7M17 7H9M17 7v8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    const ensureSrc = (video) => {
      if (!video) return;
      const dataSrc = video.getAttribute('data-src');
      if (dataSrc && video.getAttribute('src') !== dataSrc) {
        video.setAttribute('src', dataSrc);
      }
    };

    const forcePlay = (video) => {
      if (!video) return;
      ensureSrc(video);
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      const attempt = () => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              video.classList.add('watch-buy__vid--on', 'is-playing');
            })
            .catch(() => {});
        } else {
          video.classList.add('watch-buy__vid--on', 'is-playing');
        }
      };
      if (video.readyState >= 2) attempt();
      else {
        video.addEventListener('loadeddata', attempt, { once: true });
        try {
          video.load();
        } catch (e) {}
        attempt();
      }
    };

    const pauseTile = (video) => {
      if (!video) return;
      video.pause();
      video.classList.remove('watch-buy__vid--on', 'is-playing');
    };

    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const viewport = root.querySelector('[data-wb-viewport]');
      const prev = root.querySelector('[data-wb-prev]');
      const next = root.querySelector('[data-wb-next]');
      const viewer = root.querySelector('[data-wb-viewer]');
      const stage = root.querySelector('[data-wb-stage]');
      const rail = root.querySelector('[data-wb-rail]');
      const cells = [...root.querySelectorAll('[data-wb-cell]')];
      if (!viewport || !viewer || !stage || !rail || !cells.length) return;

      let activeIndex = 0;
      let progressTimer = null;
      let muted = true;
      let railOffset = 0;
      let dragStartX = 0;
      let dragDelta = 0;
      let isDragging = false;

      const tileVideos = [...root.querySelectorAll('.watch-buy__vid, .watch-buy__media > video')];

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) forcePlay(video);
              else pauseTile(video);
            });
          },
          { root: viewport, threshold: 0.45 }
        );
        tileVideos.forEach((video) => io.observe(video));
      } else {
        tileVideos.forEach((video) => forcePlay(video));
      }

      root.querySelectorAll('.watch-buy__tile').forEach((tile) => {
        const video = tile.querySelector('.watch-buy__vid, .watch-buy__media > video');
        if (!video) return;
        tile.addEventListener('mouseenter', () => forcePlay(video));
        tile.addEventListener('touchstart', () => forcePlay(video), { passive: true });
      });

      const updateNav = () => {
        if (!prev || !next) return;
        const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
        prev.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft >= max;
      };

      const step = () => {
        const cell = viewport.querySelector('.watch-buy__cell');
        if (!cell) return viewport.clientWidth * 0.8;
        return cell.getBoundingClientRect().width + 16;
      };

      prev?.addEventListener('click', () => {
        viewport.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next?.addEventListener('click', () => {
        viewport.scrollBy({ left: step(), behavior: 'smooth' });
      });
      viewport.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', () => {
        updateNav();
        if (!viewer.hidden) centerActive(false);
      });
      updateNav();

      const clearProgress = () => {
        if (progressTimer) {
          window.clearInterval(progressTimer);
          progressTimer = null;
        }
      };

      const getGap = () => {
        const styles = window.getComputedStyle(rail);
        return parseFloat(styles.columnGap || styles.gap) || 24;
      };

      const applyRailTransform = (offset, animate = true) => {
        rail.classList.toggle('is-dragging', !animate);
        rail.style.transform = `translate3d(${offset}px, 0, 0)`;
      };

      const centerActive = (animate = true) => {
        const slides = [...rail.querySelectorAll('[data-wb-slide]')];
        const active = slides[activeIndex];
        if (!active) return;
        const gap = getGap();
        let x = 0;
        for (let i = 0; i < activeIndex; i += 1) {
          x += slides[i].offsetWidth + gap;
        }
        railOffset = stage.clientWidth / 2 - active.offsetWidth / 2 - x;
        applyRailTransform(railOffset, animate);
      };

      const buildSlides = () => {
        rail.innerHTML = cells
          .map((cell, index) => {
            const title = cell.dataset.title || '';
            const price = cell.dataset.price || '';
            const url = cell.dataset.url || '#';
            const poster = cell.dataset.poster || '';
            const video = cell.dataset.video || '';
            const media = video
              ? `<video class="wb-slide__video" muted loop playsinline webkit-playsinline preload="auto" poster="${poster}" src="${video}"></video>`
              : `<img class="wb-slide__poster" src="${poster}" alt="${title.replace(/"/g, '&quot;')}" width="360" height="640">`;
            return `
              <article class="wb-slide${index === activeIndex ? ' is-active' : ''}" data-wb-slide data-index="${index}">
                <div class="wb-slide__progress" data-wb-progress><span></span></div>
                <button type="button" class="wb-slide__mute" data-wb-mute aria-label="Mute">${iconMute}</button>
                <div class="wb-slide__media">${media}</div>
                <div class="wb-slide__bottom">
                  <div class="wb-slide__product-bar">
                    <a class="wb-slide__product" href="${url}">
                      <span class="wb-slide__thumb"><img src="${poster}" alt="" width="48" height="48"></span>
                      <span class="wb-slide__meta">
                        <span class="wb-slide__title">${title}</span>
                        <span class="wb-slide__price">${price}</span>
                      </span>
                    </a>
                    <a class="wb-slide__link-icon" href="${url}" aria-label="View product">${iconLink}</a>
                    <button type="button" class="wb-slide__share" data-wb-share aria-label="Share">${iconShare}</button>
                  </div>
                </div>
              </article>
            `;
          })
          .join('');
      };

      const playActive = () => {
        clearProgress();
        rail.querySelectorAll('[data-wb-slide]').forEach((slide) => {
          const isActive = Number(slide.dataset.index) === activeIndex;
          slide.classList.toggle('is-active', isActive);
          const video = slide.querySelector('video');
          const bar = slide.querySelector('[data-wb-progress] span');
          if (video) {
            video.muted = muted;
            if (isActive) {
              video.currentTime = 0;
              forcePlay(video);
              if (!muted) video.muted = false;
              if (bar) {
                bar.style.width = '0%';
                progressTimer = window.setInterval(() => {
                  if (!video.duration || Number.isNaN(video.duration)) return;
                  bar.style.width = `${Math.min(100, (video.currentTime / video.duration) * 100)}%`;
                  if (video.ended || video.currentTime >= video.duration - 0.15) {
                    goTo(activeIndex + 1);
                  }
                }, 80);
              }
            } else {
              video.pause();
              if (bar) bar.style.width = '0%';
            }
          } else if (isActive && bar) {
            bar.style.width = '0%';
            let value = 0;
            progressTimer = window.setInterval(() => {
              value = Math.min(100, value + 1.2);
              bar.style.width = `${value}%`;
              if (value >= 100) goTo(activeIndex + 1);
            }, 80);
          }
        });

        const muteBtn = rail.querySelector('.wb-slide.is-active [data-wb-mute]');
        if (muteBtn) muteBtn.innerHTML = muted ? iconMute : iconUnmute;
        centerActive(true);
      };

      const goTo = (index) => {
        if (!cells.length) return;
        activeIndex = (index + cells.length) % cells.length;
        playActive();
      };

      const openViewer = (index) => {
        if (isDesignMode) return;
        activeIndex = index;
        buildSlides();
        viewer.hidden = false;
        document.body.classList.add('wb-viewer-open');
        requestAnimationFrame(() => {
          centerActive(false);
          playActive();
        });
      };

      const closeViewer = () => {
        clearProgress();
        rail.querySelectorAll('video').forEach((video) => video.pause());
        viewer.hidden = true;
        document.body.classList.remove('wb-viewer-open');
      };

      root.querySelectorAll('[data-wb-open]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const cell = button.closest('[data-wb-cell]');
          if (!cell) return;
          openViewer(Number(cell.dataset.index || 0));
        });
      });

      root.querySelectorAll('[data-wb-close]').forEach((el) => {
        el.addEventListener('click', closeViewer);
      });
      root.querySelector('[data-wb-viewer-prev]')?.addEventListener('click', () => goTo(activeIndex - 1));
      root.querySelector('[data-wb-viewer-next]')?.addEventListener('click', () => goTo(activeIndex + 1));

      rail.addEventListener('click', async (event) => {
        const muteBtn = event.target.closest('[data-wb-mute]');
        if (muteBtn) {
          muted = !muted;
          const video = rail.querySelector('.wb-slide.is-active video');
          if (video) {
            video.muted = muted;
            if (!muted) forcePlay(video);
          }
          muteBtn.innerHTML = muted ? iconMute : iconUnmute;
          return;
        }

        const shareBtn = event.target.closest('[data-wb-share]');
        if (shareBtn) {
          const cell = cells[activeIndex];
          const shareData = {
            title: cell?.dataset.title || document.title,
            url: cell?.dataset.url ? new URL(cell.dataset.url, window.location.origin).href : window.location.href
          };
          try {
            if (navigator.share) await navigator.share(shareData);
            else if (navigator.clipboard) await navigator.clipboard.writeText(shareData.url);
          } catch (error) {}
          return;
        }

        if (event.target.closest('.wb-slide__product, .wb-slide__link-icon')) return;

        const slide = event.target.closest('[data-wb-slide]');
        if (!slide) return;
        const index = Number(slide.dataset.index);
        if (Number.isNaN(index) || index === activeIndex) return;
        goTo(index);
      });

      const onPointerDown = (clientX) => {
        isDragging = true;
        dragStartX = clientX;
        dragDelta = 0;
        rail.classList.add('is-dragging');
      };

      const onPointerMove = (clientX) => {
        if (!isDragging) return;
        dragDelta = clientX - dragStartX;
        applyRailTransform(railOffset + dragDelta, false);
      };

      const onPointerUp = () => {
        if (!isDragging) return;
        isDragging = false;
        rail.classList.remove('is-dragging');
        const threshold = Math.min(80, stage.clientWidth * 0.12);
        if (dragDelta <= -threshold) goTo(activeIndex + 1);
        else if (dragDelta >= threshold) goTo(activeIndex - 1);
        else centerActive(true);
        dragDelta = 0;
      };

      stage.addEventListener('pointerdown', (event) => {
        if (event.button && event.button !== 0) return;
        if (event.target.closest('a, button')) return;
        stage.setPointerCapture?.(event.pointerId);
        onPointerDown(event.clientX);
      });
      stage.addEventListener('pointermove', (event) => onPointerMove(event.clientX));
      stage.addEventListener('pointerup', onPointerUp);
      stage.addEventListener('pointercancel', onPointerUp);

      document.addEventListener('keydown', (event) => {
        if (viewer.hidden) return;
        if (event.key === 'Escape') closeViewer();
        if (event.key === 'ArrowLeft') goTo(activeIndex - 1);
        if (event.key === 'ArrowRight') goTo(activeIndex + 1);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-wishlist-page]');
    if (!root) return;
    const KEY = 'stitch-wishlist';
    const grid = root.querySelector('[data-wishlist-grid]');
    const empty = root.querySelector('[data-wishlist-empty]');
    const countEl = root.querySelector('[data-wishlist-page-count]');

    const read = () => {
      try {
        const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(raw) ? raw : [];
      } catch (error) {
        return [];
      }
    };

    const write = (list) => {
      localStorage.setItem(KEY, JSON.stringify(list));
      document.dispatchEvent(new CustomEvent('stitch:wishlist-change', { detail: { count: list.length } }));
      if (window.StitchWishlist?.syncCount) window.StitchWishlist.syncCount();
    };

    const render = () => {
      const list = read();
      if (countEl) {
        countEl.textContent = list.length
          ? list.length + (list.length === 1 ? ' item' : ' items')
          : '';
      }
      if (!list.length) {
        if (empty) empty.hidden = false;
        if (grid) grid.innerHTML = '';
        return;
      }
      if (empty) empty.hidden = true;
      if (!grid) return;
      grid.innerHTML = list
        .map((item) => {
          const id = String(item.id || item);
          const title = item.title || 'Product';
          const url = item.url || '#';
          const image = item.image || '';
          const price = item.price || '';
          return (
            '<article class="wishlist-page__card" data-wish-id="' +
            id +
            '">' +
            '<div class="wishlist-page__image-wrap">' +
            (image
              ? '<a href="' +
                url +
                '"><img class="wishlist-page__image" src="' +
                image +
                '" alt="' +
                String(title).replace(/"/g, '&quot;') +
                '" width="600" height="800" loading="lazy"></a>'
              : '<a href="' + url + '" class="wishlist-page__image-wrap"></a>') +
            '<button type="button" class="wishlist-page__remove" data-wish-remove aria-label="Remove from wishlist">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.1 20.3 11 19.3C6.4 15.1 3.5 12.5 3.5 9.2 3.5 6.6 5.6 4.5 8.2 4.5c1.5 0 2.9.7 3.8 1.8C12.9 5.2 14.3 4.5 15.8 4.5c2.6 0 4.7 2.1 4.7 4.7 0 3.3-2.9 5.9-7.5 10.1l-1 1z"/></svg>' +
            '</button></div>' +
            '<a href="' +
            url +
            '"><p class="wishlist-page__name">' +
            String(title).replace(/</g, '&lt;') +
            '</p>' +
            (price ? '<p class="wishlist-page__price">' + String(price).replace(/</g, '&lt;') + '</p>' : '') +
            '</a></article>'
          );
        })
        .join('');
    };

    grid?.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-wish-remove]');
      if (!btn) return;
      event.preventDefault();
      const card = btn.closest('[data-wish-id]');
      const id = card?.getAttribute('data-wish-id');
      if (!id) return;
      write(read().filter((item) => String(item.id || item) !== id));
      render();
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
